
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/upsc-previous-question-paper",
      function () {
        return require("private-next-pages/upsc-previous-question-paper/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/upsc-previous-question-paper"])
      });
    }
  